
        var result = require("!!../../../../node_modules/css-loader/index.js!./price-change-correction.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-cashreg/price-change-correction.component.css
// module id = 2358
// module chunks = 1